<template>
	<Fragment>
		<slot v-if="hasAuthorization"/>
		<slot name="handler" :hasAuthorization="hasAuthorization" />
	</Fragment>
</template>

<script setup lang="ts">
import { authModule } from '../store'
import { UserRole } from '../../common/types/Irmao'
import { Fragment } from 'vue-fragment'
import { computed } from 'vue'

const props = withDefaults(
	defineProps<{
		requires: UserRole[] | boolean
	}>(), {
		requires: () => [],
	},
)

const hasAuthorization = computed(() => {
  return typeof props.requires === 'boolean'
    ? props.requires
    : authModule.hasAuthorization(props.requires)
})
</script>